import React from 'react'

export function StyleButton({ onToggle, style, label, active }) {
  const className = active
    ? 'richeditor-styleButton richeditor-activeButton'
    : 'richeditor-styleButton'

  return (
    <span
      className={className}
      onMouseDown={(event) => {
        event.preventDefault()
        onToggle(style)
      }}
    >
      <LabelIcon label={label} />
    </span>
  )
}

function LabelIcon({ label }) {
  if (label === 'B') {
    return <i className="far fa-bold" />
  }
  if (label === 'I') {
    return <i className="far fa-italic" />
  }

  if (label === 'H') {
    return <i className="fas fa-heading" />
  }

  return label
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/RichEditor/StyleButton.js